import { cloneDeep } from "lodash";

import { Role } from "@/acl/roles";
import { GenericProductCards } from "@/assets/constants/analysisCards";
import { GLOBAL_EVENTS } from "@/assets/constants/eventsDates";
import { UpdateFrequency } from "@/assets/constants/frequencies";
import { STANDARD_PERF_STATS_WITHOUT_BENCHMARK } from "@/assets/constants/perfStats";
import { STANDARD_ZOOM_BUTTONS } from "@/assets/constants/zoomButtons";
import exports from "@/assets/scss/exports.module.scss";

const ORG_COLOR = exports["colors-primary"];
const INTERNAL_ALLOWED_ROLES = [Role.admin, Role.superAdmin];

// ******---------- Hexagon Capital Fund ----------*****
const hexagonCapitalFundD1 = {
  productId: "hexagon-capital-fund-d1",
  storeModule: "hexagonCapitalFundD1",
  productName: "Hexagon Capital Fund D1",
  productShortName: "Hexagon Capital Fund",
  productColor: ORG_COLOR,
  allowHoldingDataModification: true,
  allowPriceDataModification: true,
  productShareClassRoot: "hexagon-capital-fund",
  isDefaultShareClass: true,
  live: {
    updateFrequency: UpdateFrequency.quarterly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet", fr: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

const hexagonCapitalFundD2 = cloneDeep(hexagonCapitalFundD1);
hexagonCapitalFundD2.productId = "hexagon-capital-fund-d2";
hexagonCapitalFundD2.storeModule = "hexagonCapitalFundD2";
hexagonCapitalFundD2.productName = "Hexagon Capital Fund D2";
hexagonCapitalFundD2.isDefaultShareClass = false;

export const PRODUCTS_DETAILS = [hexagonCapitalFundD1, hexagonCapitalFundD2];

export const PRODUCTS = PRODUCTS_DETAILS.map((details) => details.storeModule);
